import { KeysOfType } from 'src/app/helpers/utility-functions';
import ProductAsset from 'src/app/model/product-asset';
import BoardType from 'src/app/model/product/board/board-type';
import PlacementType from 'src/app/model/product/board/placement-type';
import Address from 'src/app/model/project/address';
import RegisteredAction from 'src/app/model/registered-action';
import { OfflineStorageObject } from '../../placer-offline-changes/abstract/offline-storage-object';
import { OfflineAsset } from '../../placer-offline-changes/offline-asset';
import { ToDoItem } from '../model/to-do-item';
import { ImmoIPNotExecutedHistoryItemObject } from './immo-ip-not-executed-history-item-object';

export interface ImmoIPSubProjectChangesObject
  extends OfflineStorageObject<number> {
  id: number;
  projectId: number;
  tourItemId: number;
  placerFeedback?: string;
  internalInfo?: string;
  recurringInternalInfo?: boolean;
  registeredActions?: RegisteredAction[];
  placementDone?: boolean;
  currentExecutionDate?: Date;
  completed?: ToDoItem;
  stickerInfo?: ToDoItem;
  extras?: ToDoItem;
  arrows?: ToDoItem;
  secondBoard?: ToDoItem;
  otherOrder?: ToDoItem;
  drillHolesFilled?: ToDoItem;
  offlineAssets?: OfflineAsset[];
  assets?: ProductAsset[];
  toDeleteAssetUuids?: string[];
  notExecutedHistoryItemObject?: ImmoIPNotExecutedHistoryItemObject;
  isChange?: boolean;
  boardType?: BoardType;
  placementType?: PlacementType;
  address?: Address;
}

// IMPORTANT: If you ever need to add a new ToDoItem, please add its property name to this array
export const toDoItemKeys = [
  'completed',
  'stickerInfo',
  'extras',
  'arrows',
  'secondBoard',
  'otherOrder',
  'drillHolesFilled'
];

export type ImmoIPSubProjectChangesObjectToDoItemKey = KeysOfType<
  ImmoIPSubProjectChangesObject,
  ToDoItem
>;

export function isSubProjectToDoItemProp(
  prop: string
): prop is ImmoIPSubProjectChangesObjectToDoItemKey {
  return toDoItemKeys.includes(prop);
}
